import React from 'react';

import { Filter } from '@gogame/filters';

import {
  FILTER_EVENTS,
  FILTER_APPLICATIONS,
  DEPENDENCIES,
} from 'scenes/Events/constants';
import {
  loadEventTypes,
  loadApplications,
} from 'scenes/Events/sources/filters';

export const EventsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Event Triggers'}
      name={FILTER_EVENTS}
      source={loadEventTypes}
      placeholder={'All'}
      depends={DEPENDENCIES[FILTER_EVENTS]}
      {...props}
    />
  );
};

export const ApplicationsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={loadApplications}
      placeholder={'All'}
      {...props}
    />
  );
};

export default {
  Events: EventsFilter,
  Applications: ApplicationsFilter,
};
